import { Link, useLocation } from "react-router-dom";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import NewsAndArticlesComponent from "./components/news-and-articles.component";
import { useEffect, useMemo, useState } from "react";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { useSelector } from "react-redux";
import LoadingComp from "../../components/re-usable/loading/loading";

const NewsAndArticles = () => {
  // Check if navigating to the original rss feed url
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search.toLowerCase());
  const isRssFeed = queryParams.get("rss")

  if (isRssFeed && isRssFeed.toLowerCase() === "regulatory-focus") {
    window.location.replace("/news-and-articles/rss");
  }
  // End Check

  const path = "%2FNews-And-Articles"
  const dispatch = useAppDispatch();

  const { RapsEuropeLoading: pageLoading, RapsEuropeData: pageData } = useSelector((state: RootState) => state.rapsEurope);

  const [isPageLoaded, setIsPageLoaded] = useState(false);

  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);

  useEffect(() => {
    window.scrollTo(0, 0)

    dispatch(retrievePageMenu(path));
  }, [dispatch])

  useEffect(() => {
    if (!pageLoading && pageData[0]?.result !== undefined) {
      setIsPageLoaded(true);
    }
  }, [pageData])

  if (!isPageLoaded) return <LoadingComp />

  return (
    <>
      <NewsAndArticlesComponent />

      <div className="container">
        {cachedGoogleAds}
        <p>&nbsp;</p>
      </div>
      <QuickLinksStyles />
      <div className="container-fluid" id="newslinks">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-1">
              <div>
                <Link className="ql-links" to="/news-and-articles/about-regulatory-focus">
                  <span className="ql-text">About Regulatory Focus</span>
                </Link>
              </div>
              <div>
                <Link className="ql-links" to="/news-and-articles/rf-quarterly">
                  <span className="ql-text">RF Quarterly</span>
                </Link>
              </div>
            </div>

            <div className="col-md-3 mt-1">
              <div>
                <Link className="ql-links" to="/news-and-articles/about-regulatory-focus/editorial-calendar">
                  <span className="ql-text">Editorial Calendar</span>
                </Link>
              </div>
              <div>
                <Link className="ql-links" to="/news-and-articles/editorial-advisory-committee">
                  <span className="ql-text">Editorial Advisory Committee</span>
                </Link>
              </div>
            </div>

            <div className="col-md-3 mt-1">
              <div>
                <Link className="ql-links" to="/news-and-articles/about-regulatory-focus/author-guidelines">
                  <span className="ql-text">Submissions &amp; Guidelines</span>
                </Link>
              </div>
              <div>
                <Link className="ql-links" to="/news-and-articles/copyright-clearance-center">
                  <span className="ql-text">Copyright &amp; Terms of Use</span>
                </Link>
              </div>
            </div>

            <div className="col-md-3 mt-1">
              <div>
                <a className="ql-links" href="https://www.raps-mediaplanner.com/rapsmediaplanneraccess">
                  <span className="ql-text">Advertise</span>
                </a>
              </div>
              <div>
                <Link className="ql-links" to="/who-we-are/contact-us">
                  <span className="ql-text">Contact</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const QuickLinksStyles = () => {
  return (
    <style>
      {`
        #newslinks .ql-links {
          color: white;
          font-size: 18px;
        }
        #newslinks {
            background-color: #0070B9;
            position: relative;
            padding: 0 0 5px 0;
            margin-top: 10px;
        }
        #newslinks .row {
            margin-left: 5%;
            margin-top: 5px; margin-bottom: 5px;
        }
        .news-landing .summary-latest a.link-see-more {
          font-size: 14px;
        }
      `}
    </style>
  )
}

export default NewsAndArticles;
